'use strict';

import {SectionCtrl} from "../esfasi/sectionctrl";

export class Projectreportstimelinectrl extends SectionCtrl
{
	text = {
		before: {
			key: 'a4_2_timetable_before',
			on: false,
			value: null
		},
		after: {
			key: 'a4_2_timetable_after',
			on: false,
			value: null
		}
	};
	
	rows = [];
	timetable = {
		min: 1,
		max: 5,
		range: []
	};
	
	constructor($scope, $filter, jsDataService){
		super($scope, $filter, jsDataService);

		this.dragging = false;
		this.dragRow = null;
		
		if(typeof(jsDataService.data.workpackages) !== 'undefined'){
			this.initWP(jsDataService.data.workpackages);
		}
		
	}
	
	$onInit(){
		if(typeof(this.section.instructions) !== 'undefined'){
			for(let prop in this.text){
				if(typeof(this.section.instructions[this.text[prop].key]) !== 'undefined' && this.section.instructions[this.text[prop].key].value !== ''){
					this.text[prop].on = true;
					this.text[prop].value = this.section.instructions[this.text[prop].key].value;
				}
			}
		}
	}
	
	initWP(workpackages){
		for(let wp of workpackages){
			this.rows.push(this.makeRowFromWp(wp));
			if(typeof(wp.activities) !== 'undefined'){
				for(let activity of Object.values(wp.activities)){
					this.rows.push(this.makeRowFromActivity(activity));
				}
			}
		}

		if(typeof(this.jsDataService.data.item.timeline) !== 'undefined'){
			if(typeof(this.jsDataService.data.item.timeline.min) !== 'undefined' && !isNaN(this.jsDataService.data.item.timeline.min)){
				this.timetable.min = parseInt(this.jsDataService.data.item.timeline.min);
			}
			if(typeof(this.jsDataService.data.item.timeline.max) !== 'undefined' && !isNaN(this.jsDataService.data.item.timeline.max)){
				this.timetable.max = parseInt(this.jsDataService.data.item.timeline.max);
			}
		}
		if(this.rows.length > 0){
			for(let nr=this.timetable.min; nr<=this.timetable.max; nr++){
				this.timetable.range.push(nr);
			}
		}
	}
	
	makeRowFromWp(wp){
		return {
			isWp: true,
			id: wp.id,
			number: wp.a4_1_work_activities_no,
			title: wp.a4_1_work_activities_name,
			start: parseInt(wp.a4_1_work_activities_start),
			end: parseInt(wp.a4_1_work_activities_end)
		};
	}

	makeRowFromActivity(activity) {
		const originalStart = parseInt(activity.a4_1_work_activities_activ_start) || 1;
		const originalEnd   = parseInt(activity.a4_1_work_activities_activ_end)   || 1;

		const savedStart = parseInt(activity.activ_start);
		const savedEnd   = parseInt(activity.activ_end);

		return {
			isWp: false,
			id: activity.id,
			number: activity.a4_1_work_activities_activ_no,
			title: activity.a4_1_work_activities_activ_name,

			start: originalStart,
			end: originalEnd,

			blueSelectionStart: !isNaN(savedStart) ? savedStart : originalStart,
			blueSelectionEnd:   !isNaN(savedEnd)   ? savedEnd   : originalEnd
		};
	}

	handleMouseDown(row, nr, $event) {
		if (row.isWp) return;
		const { blueSelectionStart: s, blueSelectionEnd: e } = row;
		if (s === nr && e === nr) {
			row.blueSelectionStart = null;
			row.blueSelectionEnd   = null;
			this.dragging = false;
			this.dragRow  = null;
		} else {
			this.dragStart(row, nr);
		}
		if (this.$scope.ctrlBaseForm) this.$scope.ctrlBaseForm.$setDirty();
		$event.preventDefault();
	}

	/**
	 * 
	 * @param {rowObject} row
	 * @param {integer} nr
	 * @param {string} active - md-colors value for active cell
	 * @param {string} inactive - md-colors value for inactive cell
	 * @returns {string}
	 */
	getActiveCell(row, nr, active, inactive, selStart, selEnd) {
		const start = (selStart !== undefined ? selStart : row.start);
		const end = (selEnd !== undefined ? selEnd : row.end);
		return (start <= nr && nr <= end) ? active : inactive;
	}

	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}

    autosavePostFields() {
        const reportId = (this.jsDataService && this.jsDataService.data && this.jsDataService.data.item && this.jsDataService.data.item.id) ? parseInt(this.jsDataService.data.item.id) : null;
        const reportingId = (this.jsDataService && this.jsDataService.data && this.jsDataService.data.reporting && this.jsDataService.data.reporting.contract_reporting_id) ? parseInt(this.jsDataService.data.reporting.contract_reporting_id) : null;

        const postData = { report_id: reportId, reporting_id: reportingId, workpackages: [] };
        let currentWp = null;

        this.rows.forEach(row => {
            if (row.isWp) {
                currentWp = {
                    id: row.id,
                    number: row.number,
                    title: row.title,
                    start: row.start,
                    end: row.end,
                    activities: []
                };
                postData.workpackages.push(currentWp);
            } else if (currentWp) {
                const activ_start = (typeof row.blueSelectionStart !== 'undefined') ? parseInt(row.blueSelectionStart) : row.start;
                const activ_end   = (typeof row.blueSelectionEnd   !== 'undefined') ? parseInt(row.blueSelectionEnd)   : row.end;

                currentWp.activities.push({
                    id: row.id,
                    number: row.number,
                    title: row.title,
                    activ_start,
                    activ_end
                });
            }
        });

        return postData;
    }


	dragStart(row, nr) {
		if (!row.isWp) {
			this.dragging = true;
			this.dragRow = row;
			row.blueSelectionStart = nr;
			row.blueSelectionEnd = nr;
		}
	}

	dragOver(row, nr) {
		if (this.dragging && this.dragRow === row) {
			if (nr < row.blueSelectionStart) {
				row.blueSelectionStart = nr;
			} else {
				row.blueSelectionEnd = nr;
			}
		}
	}

	dragEnd(row, nr) {
		this.dragging = false;
		this.dragRow = null;
		if(this.$scope.ctrlBaseForm) {
			this.$scope.ctrlBaseForm.$setDirty();
		}
	}
}

